import React from 'react'
import logo from "../../assets/images/Admin-20 (89).png"
import { webUrls } from '../../utils/webUrls'
import { useNavigate } from 'react-router-dom'

const MainFooter = () => {
    const navigate = useNavigate()

    const handleToWeb = () => {
        window.open('http://3.139.69.64/Vendor', "_blank")
    }

    return (
        <div className="mainFooter">
            <div className="container">
                <div className="mainFooter_top">
                    <div>
                        <p className="mainFooter_head">86kitch’n </p>
                        <div className="mainFooter_item">
                            <p onClick={() => navigate('/about')}>About</p>
                            <p onClick={() => navigate('/press')}>Press</p>
                            <p onClick={() => navigate("/blog")}>Blog</p>
                            {/* <p>Partner Center</p>
                            <p>Affiliate Center</p> */}
                        </div>
                    </div>
                    <div>
                        <p className="mainFooter_head">Services </p>
                        <div className="mainFooter_subtwo">
                            <div className="mainFooter_item">
                                <p onClick={handleToWeb}>Internet Connection</p>
                                <p onClick={handleToWeb}>POS System</p>
                                <p onClick={handleToWeb}>Multimedia Screen</p>
                                <p onClick={handleToWeb}>Drive Thru</p>
                            </div>
                            <div className="mainFooter_item">
                                <p onClick={handleToWeb}>BOM Analysis</p>
                                <p onClick={handleToWeb}>(CCTV) surveillance system</p>
                                <p onClick={handleToWeb}>Self Service Kiosl</p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <p className="mainFooter_head">Support </p>
                        <div className="mainFooter_item">
                            <p onClick={() => navigate("/help")}>Help</p>
                            <p onClick={() => navigate("/safety")}>Safety</p>
                            <p onClick={() => navigate("/termsOfUse")}>Terms of use</p>
                            <p onClick={() => navigate("/privacyPolicy")}>Privacy Policy</p>
                        </div>
                    </div>
                    <div>
                        <p className="mainFooter_head">Links</p>
                        <div className="mainFooter_item">
                            <p> <a target='_blank' rel='noreferrer' href={webUrls.marketPlace}>Marketplace </a></p>
                            {/* <p> <a target='_blank' rel='noreferrer' href={webUrls.superAdmin}>Super Admin </a></p> */}
                            <p> <a target='_blank' rel='noreferrer' href={webUrls.partnerCenter}>Partner Center </a></p>
                        </div>
                    </div>
                </div>
                <div className="mainFooter_bottom">
                    <p>2023 86Kitch’n</p>
                    <img src={logo} alt="" />
                </div>
            </div>
        </div>
    )
}
export default MainFooter